// extracted by mini-css-extract-plugin
export default {"container":"Waiting__container--BD5hV","patientName":"Waiting__patientName--ozg0B","connecting":"Waiting__connecting--l0ZIw","ava":"Waiting__ava--Ds527"};